<div>
    <div class="row align-items-center" style="width: 100%">
        <div class="col-2">
            <div class="icon">
                <img [src]="imgSrc" />
            </div>
        </div>
        <div class="col-8">
            <div *ngIf="title()" [class]="opts.titleClass" [attr.aria-label]="title()" class="custom-title">
                {{ title() }}
            </div>
            <div
                *ngIf="message() && opts.enableHtml"
                role="alert"
                aria-live="polite"
                class="custom-message"
                [class]="opts.messageClass"
                [innerHTML]="message()"
            ></div>
            <div
                *ngIf="message() && !opts.enableHtml"
                role="alert"
                aria-live="polite"
                class="custom-message"
                [class]="opts.messageClass"
                [attr.aria-label]="message()"
            >
                {{ message() }}
            </div>
        </div>
        <div class="col-md-2 text-end">
            <a *ngIf="!opts.closeButton || false" class="btn btn-pink btn-sm" (click)="action($event)">
                {{ undoString }}
            </a>
            <a *ngIf="opts.closeButton || false" (click)="remove()" class="btn btn-sm toast-close-button"> &times; </a>
        </div>
    </div>
</div>
